module.exports = __webpack_public_path__ + "static/media/1.07be95e1.png";